const { getOffsetTop } = window.BAO.Utils

class FooterBackground extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setOverlayOpacity()
  }

  setOverlayOpacity () {
    if (!this.offsetHeight) return

    const maxOpacity = 0.6

    const elementHeight = this.offsetHeight

    const offsetTop = getOffsetTop(this)
    const elementStartPoint = offsetTop - window.innerHeight / 2
    const elementEndPoint = offsetTop + elementHeight - window.innerHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.els.overlay.element.style.setProperty('--Overlay', '0')

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.els.overlay.element.style.setProperty('--Overlay', maxOpacity)

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const opacityAmount = maxOpacity * scrollYAsAPercentageOfJourney

    this.els.overlay.element.style.setProperty('--Overlay', opacityAmount)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.removeEventListener('scroll', this.onScroll)
  }
}

if (!customElements.get('footer-background')) {
  customElements.define('footer-background', FooterBackground)
}
